'use client';

import styled from '@benzinga/themetron';

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  padding: 1rem;
  border: 1px solid #ebebeb;
  border-radius: 0.25rem;
  h2.core-block {
    font-size: 24px !important;
    margin-top: 1rem !important;
    margin-bottom: 0.05rem !important;
  }
  h5 {
    font-weight: 600;
    color: #242429;
    margin-bottom: 0.5rem;
    letter-spacing: 0;
    font-size: 14px;
  }
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:first-of-type {
      margin-top: 0 !important;
    }
  }
`;

export const CallToActionCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.colorPalette.gray200};
  box-shadow: ${({ theme }) => theme.shadow.default};
  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.lg};
  }
  h5 {
    font-size: ${({ theme }) => theme.fontSize['2xl']};
  }
`;

export default Card;
